import { connect } from 'react-redux';
import NotificationPopup from './NotificationPopup';

const mapStateToProps = (state) => ({
  notificationServers: state.fas.configuration.configuration.notificationServers,
});

export default connect(mapStateToProps)(NotificationPopup);
